import React , { createContext, useState, useEffect } from 'react';

export const UserContext = createContext({});

export const UserContextProvider = ({ children }) => {
    const [username,setUsername]=useState('');
    const [timeout,setTimeout]=useState('0');
    const [token,setToken]=useState('');
    const [userLoading,setUserLoading]=useState(false);
    const [isLoggedIn,setIsLoggedIn]=useState(false);
    const [userID,setUserID]=useState(null);
    console.log('initializing',localStorage.getItem('username'))
    
    

    useEffect(()=> {
        setToken(localStorage.getItem('AOD:token'));
        setTimeout(localStorage.getItem('AOD:timeout'));
        setUsername(localStorage.getItem('AOD:username')||'');
        setUserID(localStorage.getItem('AOD:userid'));
        } ,[]);

    const ops = {
        username,setUsername,
        userLoading,setUserLoading,
        isLoggedIn,setIsLoggedIn,
        timeout,setTimeout,
        token,setToken,
        userID,setUserID
    };
    return (
        <UserContext.Provider value={ops}>{children}</UserContext.Provider>
    );
    };